import fetch from "../utils/request";

//提交订单
export const apiSubmitOrder = data =>
  fetch("/website/order", {
    method: "post",
    data
  });

//订单列表
export const apiGetOrderList = () => fetch(`/website/order`);
